module.exports = __webpack_public_path__ + "img/20220423_160830.c914e898.jpg";